import { AuthApi, HomeApi, ModApi, UserApi } from '@/features';
import { RoDependencies } from '@/types';
import { browserHistory } from '@/utils';
import { applyMiddleware, createStore, Middleware, Store } from 'redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { composeWithDevTools } from 'redux-devtools-extension';
import { createEpicMiddleware, Epic } from 'redux-observable';

import { rootReducer } from './reducer';
import { HintApi } from '@/features/hint/hint.api';
import { MemeApi } from '@/features/meme/meme.api';
import { CarouselApi } from '@/features/carousel/carousel.api';
import { CompilationApi } from '@/features/compilation/compilation.api';

interface ConfigureStoreOptions {
  epic: Epic;
  middlewares: Middleware[];
}

function configureDependency(): RoDependencies {
  return {
    history: browserHistory,
    authApi: new AuthApi(),
    homeApi: new HomeApi(),
    userApi: new UserApi(),
    modApi: new ModApi(),
    memeApi: new MemeApi(),
    hintApi: new HintApi(),
    compilationApi: new CompilationApi(),
    carouselApi: new CarouselApi(),
  };
}

export function configureStore({ epic, middlewares = [] }: ConfigureStoreOptions): Store<unknown> {
  const dependencies = configureDependency();
  const epicMiddleware = createEpicMiddleware({
    dependencies,
  });
  // TODO (luchko): add compose from redux for production build before release.
  const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(epicMiddleware, ...middlewares)));
  epicMiddleware.run(epic);

  return store;
}
